import TemplateView from '../../../../TemplateView'
import UserWithAccessRights from '../../../../store/UserWithAccessRights'
import messageResource from '../../../../messageResource'
import CopyUserSelector from '../../../../administration/userManagement/CopyUserSelector'
import CopyAssignmentsFromButton from '../../../../administration/userManagement/CopyAssignmentsFromButton'
import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {getCopyUserFrom, getCopyUserId, getPanelUserFirstName, getSelectorsUsers, getUserFromAssignedUsers} from '../selectors'
import {isTZGEnabled, isUGREnabled} from '../../../../features/selectors'
import {getTimeZoneGroups, getUserGroupsWithDefault} from '../../../../entities/selectors'
import {cancelCopy, copyAssignments, loadUserFromAssignedUsers} from '../actions'
import {userNameLower} from '../../../../util/pluralizeUtils'
import DropdownDialogWithPointerWrapper from '../../../../components/DropdownDialogWithPointerWrapper'
import ScrollableContainer from '../../../../util/ScrollableContainer'
import UsersList from './UsersList'
import {timeZoneGroupsComparator, userGroupsComparator} from '../../../../atUtils'

class CopyContent extends TemplateView {
    constructor({
        onCancel = () => {},
        onSelectUser = (userId) => {},
        onCopy = () => {},
        refreshScrollCb = () => {},
    } = {}) {
        super()

        this.params = {
            onCancel,
            onSelectUser,
            onCopy,
            refreshScrollCb,
        }

        this.state = {
            userId: null,
            userFrom: null,
            userTo: null,
            viewer: null,

            userFromAssignedUsers: [],

            users: [],
            userGroups: {},
            timeZoneGroups: {},

            ugrEnabled: true,
            tzgEnabled: true,
        }

        this.onAnyStatePropertyChanged(['userFrom', 'userTo'], ({userFrom}) => {
            this.copyAssignmentsButton.setState({
                selectedUser: userFrom,
            })
            this._updateCommentNote()
        })

        this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled'], () => {
            const usersWithAccessRights = this.state.users.map(userFrom => UserWithAccessRights.fromRPC(userFrom))

            this.copyUserSelector.setState({
                users: usersWithAccessRights,
                ugrEnabled: this.state.ugrEnabled,
                userGroups: Object.values(this.state.userGroups).sort(userGroupsComparator),
                tzgEnabled: this.state.tzgEnabled,
                timeZoneGroups: Object.values(this.state.timeZoneGroups).sort(timeZoneGroupsComparator),
            })
        })

        this.onStatePropertyChanged('userId', (userId) => {
            this.$copyButton.toggleClass('disabled', userId === null)
        })

        this.onStatePropertyChanged('userFromAssignedUsers', users => {
            this.$users
                .toggleClass('disabled', users.length === 0)
                .text(users.length + ' ' + userNameLower(users.length))

            this.usersList.setState({
                showGroups: this.state.ugrEnabled,
                items: users,
                groups: this.state.userGroups,
            })
        })
    }

    templateHtml() {
        return '<div class="copyContent">' +
               '  <div class="title"><%-title%></div>' +
               '  <div class="userSelector"/>' +
               '  <div class="copyInfo">' +
               '    <div class="usersInfo">' +
               '      <div class="title"><%-counterTitle%></div>' +
               '      <div class="users"></div>' +
               '    </div>' +
               '    <div class="commentNote"/>' +
               '  </div>' +
               '  <div class="buttonsSection">' +
               '    <div class="copyButton"><%-copy%></div>' +
               '    <div class="cancelButton"><%-cancel%></div>' +
               '  </div>' +
               '</div>'
    }

    templateModel() {
        return {
            title: messageResource.getMessage('user.panel.permissions.team_assignments.copy.title'),
            counterTitle: messageResource.getMessage('work_assignments.panel.copy.counter_title'),
            copy: messageResource.getMessage('common.copy'),
            cancel: messageResource.getMessage('common.cancel'),
        }
    }

    afterRender() {
        this.$userSelector = this.find('.userSelector')
        this.$countersSection = this.find('.counters')
        this.$copyButton = this.find('.copyButton')
        this.$cancelButton = this.find('.cancelButton')

        this.$cancelButton.click(() => {
            this.params.onCancel()
        })

        this.$copyButton.click(() => {
            if (this._copyEnabled()) {
                this.params.onCopy()
            }
        })

        this.copyUserSelector = new CopyUserSelector({
            title: messageResource.getMessage("user.add.js.copy_setting.selector.label"),
            selectionCallback: (user) => {
                this.params.onSelectUser(user.id)
                this.copyUserSelector.hide()
            },
            onHideCb: () => {
                this.$el.removeClass('withUserSelector')
                this.params.refreshScrollCb()
            },
            showPermissionIcons: false,
            renderTo: this.getEl(),
        }).init()

        this.copyAssignmentsButton = new CopyAssignmentsFromButton().init(this.$userSelector)
        this.copyAssignmentsButton.bindClick(() => {
            this.copyUserSelector.showAt(this.copyAssignmentsButton.$el, "t-b")
            this.$el.toggleClass('withUserSelector', true)
            this.params.refreshScrollCb()
        })

        this.$users = this.find('.users')
        this.$users.click(() => {
            if (this.state.userFromAssignedUsers.length > 0) {
                this.usersListDialog.showAt(this.$users, {
                    my: "center top",
                    at: "center bottom",
                })
                this.$el.toggleClass('withUserSelector', true)
                this.params.refreshScrollCb()
                this.usersList.forceUpdate()
            }
        })

        this.usersList = new ScrollableContainer(null, new UsersList({
            additionalClass: 'assignedUsersList'
        }), {
            containerClass: 'assignedUsersListScrollableWrapper'
        })

        this.usersListDialog = new DropdownDialogWithPointerWrapper({
            dialog: this.usersList,
            dialogOffsets: {
                top: 10,
                left: 70
            },
            onHide: () => {
                this.$el.removeClass('withUserSelector')
                this.params.refreshScrollCb()
            }
        }).init(this.$el)

        this.$copyInfo = this.find('.copyInfo')
        this.$commentNote = this.find('.commentNote')
    }

    _copyEnabled() {
        return this.state.userId !== null
    }

    _updateCommentNote() {
        this.$copyInfo.toggleClass('invisible', !this.state.userFrom)
        if (this.state.userTo) {
            this.$commentNote.text(messageResource.getMessage('user.panel.permissions.team_assignments.copy.note', [this.state.userTo]))
        } else {
            this.$commentNote.empty()
        }
    }
}

export default connect(
    state => ({
        userId: getCopyUserId(state),
        userFrom: getCopyUserFrom(state),
        userTo: getPanelUserFirstName(state),
        userFromAssignedUsers: getUserFromAssignedUsers(state),

        users: getSelectorsUsers(state),
        userGroups: getUserGroupsWithDefault(state),
        timeZoneGroups: getTimeZoneGroups(state),

        ugrEnabled: isUGREnabled(state),
        tzgEnabled: isTZGEnabled(state),
    }),
    dispatch => ({
        onSelectUser: bindActionCreators(loadUserFromAssignedUsers, dispatch),
        onCopy: bindActionCreators(copyAssignments, dispatch),
        onCancel: bindActionCreators(cancelCopy, dispatch),
    })
)(CopyContent)



// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/components/CopyContent.js